import type { CellarModel } from './cellars.types';
import type { TemperatureTrend } from './common.types';
import type { FobModel } from './fob.types';
import type { VenueModel } from './venues.types';

export enum RemoteCoolerStatusType {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
  ARCHIVED = 'Archived'
}

export enum RemoteCoolerType {
  INTEGRAL = 'Integral',
  SPLIT = 'Split',
  LANCER = 'Lancer',
  CASK = 'Cask',
  UNDER_COUNTER = 'Under Counter'
}

export enum RemoteCoolerLocation {
  IN_CELLAR = 'In Cellar',
  OUT_OF_CELLAR = 'Out of Cellar'
}

export interface RemoteCoolerModel {
  id: string;
  position: number;
  name: string;
  maxLines: number | null;
  type: RemoteCoolerType;
  minTemperature: number | null;
  maxTemperature: number | null;
  trend?: TemperatureTrend[];
  topPumpReturnRate: string | null;
  description: string | null;
  status: RemoteCoolerStatusType;
  location: RemoteCoolerLocation | null;
  venue: VenueModel;
  cellar: CellarModel | null;
  cellarId: string;
  fobs: FobModel[];
}

export interface CreateRemoteCoolerParams {
  position: number;
  status: RemoteCoolerStatusType;
  type: RemoteCoolerType;
  location?: RemoteCoolerLocation | null;
  topPumpReturnRate: string | null;
  description: string | null;
  cellarId: string;
  shouldShift: boolean | null;
}

export interface UpdateRemoteCoolerParams extends CreateRemoteCoolerParams {
  remoteCoolerId: string | null;
}

export interface DeleteRemoteCoolerParams {
  remoteCoolerId: string;
}

export interface ListRemoteCoolerResponse {
  result: RemoteCoolerModel[];
  limit: number;
  offset: number;
  count: number;
}

export interface ListAllRemoteCoolerResponse {
  allRemotesResult: RemoteCoolerModel[];
}

export type RemoteCoolerSortingFields = 'name' | 'status' | 'type';
